var path = 'src/app/components/administration/prints/prints-page.template.html';
var html = "<breadcrumbs></breadcrumbs>\n<section class=\"box\">\n  <sub-header label=\"$ctrl.headerLabel\" header=\"$ctrl.headerTitle\"></sub-header>\n\n  <ng-transclude></ng-transclude>\n</section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;